import React from 'react';
import { Link } from 'react-router-dom';

const DeskBookingLink = (): React.ReactElement => (
  <Link to="/desks" className="btn mini-stats-btn desk-booking-link" title="Desk booking" aria-label="Desk booking">
    <i className="fa fa-desktop" aria-hidden="true" />
  </Link>
);

export default DeskBookingLink;
